const AboutIllustration2 = (props) => (
  <svg
    width={618}
    height={434}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="a"
      maskUnits="userSpaceOnUse"
      x={-3.37}
      y={-269.103}
      width={706.333}
      height={706.333}
      fill="#000"
    >
      <path fill="#fff" d="M-3.37-269.103h706.333V437.23H-3.37z" />
      <path d="M146.961-62.08C66.248 49.943 91.63 206.186 203.653 286.899c112.022 80.713 268.265 55.331 348.978-56.692 80.713-112.022 55.332-268.265-56.691-348.978-112.023-80.713-268.266-55.332-348.979 56.69Zm401.612 289.363c-79.098 109.781-232.215 134.655-341.996 55.557C96.796 203.742 71.922 50.625 151.02-59.156c79.098-109.781 232.215-134.655 341.996-55.557 109.781 79.098 134.654 232.215 55.557 341.996Z" />
    </mask>
    <path
      d="M146.961-62.08C66.248 49.943 91.63 206.186 203.653 286.899c112.022 80.713 268.265 55.331 348.978-56.692 80.713-112.022 55.332-268.265-56.691-348.978-112.023-80.713-268.266-55.332-348.979 56.69Zm401.612 289.363c-79.098 109.781-232.215 134.655-341.996 55.557C96.796 203.742 71.922 50.625 151.02-59.156c79.098-109.781 232.215-134.655 341.996-55.557 109.781 79.098 134.654 232.215 55.557 341.996Z"
      fill="#D6FEAE"
    />
    <path
      d="M146.961-62.08C66.248 49.943 91.63 206.186 203.653 286.899c112.022 80.713 268.265 55.331 348.978-56.692 80.713-112.022 55.332-268.265-56.691-348.978-112.023-80.713-268.266-55.332-348.979 56.69Zm401.612 289.363c-79.098 109.781-232.215 134.655-341.996 55.557C96.796 203.742 71.922 50.625 151.02-59.156c79.098-109.781 232.215-134.655 341.996-55.557 109.781 79.098 134.654 232.215 55.557 341.996Z"
      stroke="#D6FEAE"
      strokeWidth={6}
      mask="url(#a)"
    />
    <ellipse cx={600} cy={36.5} rx={155} ry={152.5} fill="#E96D6D" />
    <circle
      cx={498}
      cy={144}
      r={56}
      fill="#D6FEAE"
      stroke="#5171A5"
      strokeWidth={8}
    />
  </svg>
);

export default AboutIllustration2;
